import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  limitInfo: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 4,
    gap: 4,
  },
  stateProgressBar: {
    width: '100%',
  },
  currencyValueCode: {
    color: theme.color.greys[50],
  },
}), { name: 'SavingsProgressBar', index: StylesIndexInjections.UI_MOLECULES });
